import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./layouts/admin/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Program from "./pages/Program";
import ProgramAdd from "./pages/ProgramAction";
import ProgramBasicsEdit from "./pages/ProgramEdit";
import { ToastContainer } from "react-toastify";
import { ProtectedRoute } from "./components/ProtectedRoute";
import DefaultLayouts from "./layouts/frontend/Layout";
import Home from "./pages/frontend/Home";
import ProgramDetail from "./pages/frontend/ProgramDetail";
import Register from "./pages/frontend/Register";
import VerifyEmail from "./pages/frontend/VerifyEmail";
import Payment from "./strip/Payment";
import UserLayout from "./layouts/frontend/UserLayout";
import Bookings from "./pages/frontend/Bookings";
import Profile from "./pages/frontend/Profile";
import ThankYou from "./pages/frontend/ThankYou";
import ProgramsList from "./pages/frontend/Programs";
import AllBookings from "./pages/BookingList";
import PatientsList from "./pages/PatientList";
import NewsletterList from "./pages/NewsletterList";
import ContactInquiriesList from "./pages/ContactList";
import AdminSettings from "./pages/AdminSettings";
import BookingsDetails from "./pages/frontend/BookingDetails";
import Contact from "./pages/frontend/Contact";
import Terms from "./pages/frontend/Terms";
import PrivacyPolicy from "./pages/frontend/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Auth & Admin Login */}
        <Route path="/admin/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/thankyou" element={<ProtectedRoute><ThankYou /></ProtectedRoute>} />

        {/* Public & Frontend Pages */}
        <Route path="/" element={<DefaultLayouts />}>
          <Route path="/" element={<Home />} />
          <Route path="/program/:programSlug" element={<ProgramDetail />} />
          <Route path="/programs/" element={<ProgramsList />} />
          <Route path="/contact/" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/conditions-generales" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/checkout" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
        </Route>

        {/* User Dashboard */}
        <Route path="/" element={<UserLayout />}>
          <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
          <Route path="/booking/:bookingId" element={<ProtectedRoute><BookingsDetails /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        </Route>

        {/* Admin Dashboard */}
        <Route path="/" element={<Layout />}>
          <Route
            path="admin/dashboard"
            element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
          />
          <Route
            path="admin/programs"
            element={<ProtectedRoute><Program /></ProtectedRoute>}
          />
          <Route
            path="admin/bookings"
            element={<ProtectedRoute><AllBookings /></ProtectedRoute>}
          />
          <Route
            path="admin/patients"
            element={<ProtectedRoute><PatientsList /></ProtectedRoute>}
          />
          <Route
            path="admin/newsletter"
            element={<ProtectedRoute><NewsletterList /></ProtectedRoute>}
          />
          <Route
            path="admin/contacts"
            element={<ProtectedRoute><ContactInquiriesList /></ProtectedRoute>}
          />
          <Route
            path="admin/settings"
            element={<ProtectedRoute><AdminSettings /></ProtectedRoute>}
          />
          <Route
            path="admin/programs/add"
            element={<ProtectedRoute><ProgramAdd /></ProtectedRoute>}
          />
          <Route
            path="admin/programs/edit/:id"
            element={<ProtectedRoute><ProgramBasicsEdit /></ProtectedRoute>}
          />
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
